export default __webpack_public_path__ + "static/media/blog-img95.16fa7549.jpg";